<template>
  <fn-page-container>
    <fn-section
      constrained="m"
      padding-top="m"
      padding-bottom="m"
      background-color="sand-light"
    >
      <fn-error-intro
        :image="errorImage"
        :title="$t('newsletter.errors.generalTitle')"
        :description="errorMessage"
      />
    </fn-section>
  </fn-page-container>
</template>

<script setup lang="ts">
import errorImage from '@/assets/img/error-img.jpg';

definePageMeta({
  name: 'newsletter-action-redirect',
});

const { $i18n } = useNuxtApp();
const { params, query } = useRoute();
const errorMessage = ref<string>();

const actionsRedirectMap = {
  confirm: 'url.newsletterPublicPreferences',
  preferences: 'url.newsletterPublicPreferences',
  unsubscribe: 'url.newsletterPublicUnsubscribe',
};

const positiveResults = ['OK', 'CONFIRMED'];
const negativeResults = ['EXPIRED', 'NOT_FOUND', 'ERROR'];
const allowedResults = [...positiveResults, ...negativeResults];

if (
  !actionsRedirectMap[params.action as keyof typeof actionsRedirectMap] ||
  !allowedResults.includes(query.result as string)
) {
  useCmsErrorPage(400);
}

if (positiveResults.includes(query.result as string) && query.token) {
  // manually setting the nldoi param so that marketing can track
  let doiParam = '';
  if (query.result === 'OK') {
    doiParam = '&NLDOI=1';
  }

  await navigateTo(
    `${$i18n.t(`${actionsRedirectMap[params.action as keyof typeof actionsRedirectMap]}`)}?token=${query.token}${doiParam}`,
    {
      redirectCode: 302,
    },
  );
} else {
  errorMessage.value = $i18n.t(`newsletter.errors.${params.action}.${query.result}`);
}
</script>
